var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_7248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0313 6.35633C14.1506 6.47567 14.1746 6.61901 14.1029 6.76233L9.11175 17.4613C9.04008 17.6046 8.89675 17.7002 8.72958 17.7002C8.70574 17.7002 8.65791 17.7002 8.61024 17.6763C8.51473 17.6525 8.41922 17.5808 8.37139 17.5091C8.32357 17.4136 8.29973 17.342 8.32357 17.2226L9.92364 10.6313C10.0191 10.2253 9.66096 9.8671 9.25494 9.9626L6.38904 10.6791H6.26969C6.15035 10.6791 6.05469 10.6553 5.98318 10.5836C5.86384 10.4881 5.83985 10.3686 5.86383 10.2254L7.7267 2.60698C7.75054 2.51147 7.79837 2.43981 7.87004 2.39198C7.94171 2.34415 8.03721 2.32031 8.13272 2.32031H11.1658C11.2851 2.32031 11.3808 2.36814 11.4523 2.43966C11.524 2.51132 11.5716 2.60683 11.5716 2.70234C11.5716 2.75016 11.5478 2.79784 11.5238 2.86951L10.2341 6.38012C10.1148 6.71446 10.4013 7.02498 10.7356 6.95332L13.6015 6.2368C13.6493 6.21296 13.697 6.21296 13.7208 6.21296C13.8403 6.21296 13.9358 6.26079 14.0313 6.3563L14.0313 6.35633Z",
    fill: "#F79009"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_7248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetir);
export default __webpack_public_path__ + "static/media/petir.4786dd7a5b6acbe3ea4f7abc17fb0c0d.svg";
export { ForwardRef as ReactComponent };